import { Component, Input } from "@angular/core";
import { Form, FormElement, ParameterTypeModel, TranslationManager, ViewState } from "src/common";
import { ParameterTypeViewModel } from "./parameter-type.model";

@Component({
    selector: 'parameter-type',
    templateUrl: 'parameter-type.component.html'
})

export class ParameterTypeComponent {

    @Input() state: ViewState;
	viewState = ViewState;
    private _model: ParameterTypeViewModel;

    constructor() {
        this.initForm();
    }

    @Input() set model(value: ParameterTypeViewModel) {
        this._model = value;
        this._model.isValid = this.isValid.bind(this);
        this._model.getValue = this.getValue.bind(this);
        this.mapModelToForm();
    }

    form: Form = new Form();

	translationManager = TranslationManager;

    private initForm() {
        this.form.elements['value'] = new FormElement();
		this.form.elements['value'].state.mandatory = true;
        this.form.elements['valueName'] = new FormElement();
    }

    private mapModelToForm() {
        this.form.elements['value'].value = this._model.value;

        if (this._model.value) {
            let option: any = this._model.options.find(s => s.id == this._model.value);

            if (option) {
                this.form.elements['valueName'].value = TranslationManager.getTranslation('ParameterType-UniqueIdentifier#' + option.uniqueIdentifier);
            }
        }
    }

    isValid(): boolean {
        return this.form.isValid();
    }

    getValue(): number {
        return parseInt(this.form.elements['value'].value);
    }

    valueChange(event: any) {

    }
}
